export var sortBy = function (key) { return function (a, b) {
    if (a[key] < b[key]) {
        return -1;
    }
    else if (a[key] === b[key]) {
        return 0;
    }
    return 1;
}; };
//# sourceMappingURL=sort.js.map